import { createAsyncThunk } from '@reduxjs/toolkit';
import { Middleware } from 'redux';
import { ApplicationState } from '../store';
import { AppDispatch } from '../store';
import { fieldsActions } from '../actions/fields.actions';

import axios from "axios";
import { REACT_APP_FIELDS_URL } from '../../AppConfig';
import { IField } from '../../Types/Field';


// thunkApi has extra.jwt in it somehow???
export const fetchAllFields = createAsyncThunk<
  IField[],
  string,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'fields/fetchAllFields',
    async (placeholder, thunkApi) => {
      //console.log('fields/fetchAllFields', thunkApi);
      thunkApi.dispatch(fieldsActions.loadingStart);
      const config = {
        headers: {
          "Authorization": `Bearer ${thunkApi.getState().security.token}`,
          'Content-Type': 'application/json',
        }
      };

      console.log('headers: ', config);
      let data: IField[] = [];

      await axios.get(
        REACT_APP_FIELDS_URL + "v1/fields"
        , config
      )
        .then((response) => {
          if (response.data != null) {
            data = response.data;
          }
        })
        .catch(error => {
          console.log("fields/fetchAllFields error: ", error);
          thunkApi.dispatch(fieldsActions.replaceFields([] as IField[]));
          // Should return a payload that gives the error!
          return [] as IField[];
        })

      return data;
    }
  );

function save(fields: IField[], token: string): void {
  // console.log("save: ", JSON.stringify(fields))
  if (fields.length === 0) { return; }

  const config = {
    headers: {
      "Authorization": `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  };

  // API taks an array so make sure to wrap it with array brackets.
  axios.post(
    REACT_APP_FIELDS_URL + "v1/fields"
    , JSON.stringify(fields)
    , config
  )
    .then((response) => {
      console.log('save response: ', response);
    })
    .catch(error => {
      console.log(error);
    });
}

function update(fields: IField[], token: string): void {
  //console.log("Update:", fields);
  if (fields.length === 0) { return; }

  const config = {
    headers: {
      "Authorization": `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  };

  fields.forEach(f => {
    // API taks an array so make sure to wrap it with array brackets.
    axios.put(
      REACT_APP_FIELDS_URL + "v1/fields/" + f.id
      , JSON.stringify(f)
      , config
    )
      .then((response) => {
        console.log('update response: ', response);
      })
      .catch(error => {
        console.log(error);
      });
  });
}


export const addField = createAsyncThunk<
  void,
  IField[],
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'fields/addField',
    async (fields, thunkApi) => {
      thunkApi.dispatch(fieldsActions.savingStart);

      const newFields = fields.filter(f => f.id === "");
      save(newFields, thunkApi.getState().security.token);

      const updateFields = fields.filter(f => f.id !== "");
      update(updateFields, thunkApi.getState().security.token);

      thunkApi.dispatch(fieldsActions.savingFinished);
      return;
    }
  );

export const deleteField = createAsyncThunk<
  IField,
  string,
  {
    // Optional fields for defining thunkApi field types
    dispatch: AppDispatch
    state: ApplicationState
    extra: {
      jwt: string
    }
    requestId: string
    signal: AbortSignal
  }>(
    'fields/deleteField',
    async (id, thunkApi) => {
      const idx = thunkApi.getState().fields.fields.findIndex(x => x.id === id);
      if (idx < 0) {
        return {} as IField;
      }

      const field: IField = thunkApi.getState().fields.fields[idx];
      const config = {
        headers: {
          "Authorization": `Bearer ${thunkApi.getState().security.token}`,
          'Content-Type': 'application/json',
        }
      };

      axios.delete(
        REACT_APP_FIELDS_URL + "v1/fields/" + field.id
        , config
      )
        .then((response) => {
          console.log('delete response: ', response);
          thunkApi.dispatch(fieldsActions.deleteField(field));
        })
        .catch(error => {
          console.log(error);
        });

      return field;
    }
  );

const fields: Middleware = store => next => action => {
  let result = next(action)
  if (action.type === fieldsActions.replaceFields.type) {
    fetchAllFields(store.getState());
  } else if (action.type === fieldsActions.deleteField.type) {
    deleteField(store.getState());
  } else if (action.type === fieldsActions.addField.type) {
    addField(store.getState());
  }

  return result
}

export default fields;